// CSS Modules - component class name: FormFilter__

<template>
  <div>
    <form ref="FilterForm" :class="$style.container">
      <div v-if="canShowSearch()" :class="$style.search">
        <Search
          :searchPlaceholder="config.texts.searchPlaceholder"
          @submitted="getFaqSearchResults"
          @reset="searchReset"
        />
      </div>
      <div
        v-if="
          configFilters && configFilters.length > 0 && selectOptions.length > 0
        "
        :class="$style.selects"
      >
        <div class="columns is-multiline">
          <div
            :class="[
              configFilters.length < 5
                ? 'is-one-quarter-desktop'
                : 'is-one-fifth-desktop',
              'column is-half-tablet'
            ]"
            v-for="(configFilter, index) in configFilters"
            :key="index"
          >
            <FormSelect
              :ref="configFilter.key"
              :hasFilter="configFilter.hasFilter"
              v-model="configFilter.initialSelectOption"
              :value="getInitialFilterValue(configFilter)"
              :label="configFilter.label"
              :colour="configFilter.colour"
              :options="selectOptions[index]"
              :initialOption="configFilter.initialSelectOption"
              @input="updateFilters(configFilter)"
              v-show="selectOptions[index]"
            />
          </div>
          <div v-if="allowReset" :class="['column']">
            <a :class="$style.filterReset" @click="reset(false)">{{
              config.texts.resetText
            }}</a>
          </div>
        </div>
      </div>
      <div
        v-if="
          config.texts.helpText &&
            !config.loadInitialData &&
            !hasResults &&
            !config.withImageMap
        "
        class="SubPage__mobileSpaced"
      >
        {{ config.texts.helpText }}
      </div>
      <div
        v-if="config.texts.resultText && !config.withImageMap && !loadData"
        class="SubPage__mobileSpaced"
      >
        {{ config.texts.resultText }}<span>{{ filteredItems.length }}</span>
      </div>
      <div v-else-if="loadData" class="preloadFilter">
        <Loading />
      </div>
    </form>
    <div
      v-if="config.withTeasers && !hasResults"
      :class="[$style.teasers, 'columns is-multiline']"
    >
      <div
        :key="index"
        v-for="(teaser, index) in data.teasers"
        class="column is-half-tablet is-one-third-desktop"
      >
        <ContentOverviewTeaser
          :image="teaser.image"
          :title="teaser.title"
          @clicked="updateFromTeaser(teaser.title)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import FormSelect from "../FormSelect/FormSelect";
import Loading from "../Loading/Loading";
import Search from "../Search/Search";
import ContentOverviewTeaser from "../ContentOverviewTeaser/ContentOverviewTeaser";
import { CategoryKeys } from "../DownloadList/constants/categoryKeys";
import { sortInGivenArray } from "../../utils/sort";
import {
  FormFilterDataTypeEnum,
  ListCategory
} from "../../globals/constants/formFilter";
import { convertISODateTimeToLocaleDate } from "../../utils/dateTime";
import { DownloadCategory } from "../../globals/constants/download";
// TODO: this is a quick fix for 'URLSearchParams' in IE11. Full solution is to upgrade babel to > v7.4.0 and core-js to > v3.
import "url-search-params-polyfill";
import { getValueByParameterCaseInsensitive } from "../../utils/helper";
import getSearchResultFromUrl from "../../xhr/search/getSearchResultFromUrl";

// TODO: the whole component should be refactored and/or rewritten
export default {
  name: "FormFilter",
  components: {
    FormSelect,
    Search,
    Loading,
    ContentOverviewTeaser
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    },
    allowReset: {
      type: Boolean,
      default: false
    },
    allowOnlyInitialIds: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      data: {},
      hasResults: false,
      fullJsonItems: [],
      jsonItems: [],
      filteredItems: [],
      filters: [],
      selectOptions: [],
      categoryKeys: [],
      preFilterCategories: [],
      preFilterValues: [],
      preFiltersProcessed: false,
      configFilters: [],
      initialSelectOption: "",
      loadData: false,
      searchContainer: window.searchContainer,
      disableExternalDocuments: window.disableExternalDocuments,
      fetchItemsCounter: 0,
      allowedIds: []
    };
  },
  methods: {
    getContentFromUrl(url) {
      this.setLoadingData(true);
      this.hasResults = false;
      axios
        .get(url)
        .then(response => {
          this.data = response.data;

          // Filter for FAQ
          if (this.allowOnlyInitialIds) {
            this.allowedIds = this.data.items.map(item => item.id.toString());
          }

          if (this.config.withExternalData) {
            // External data has to be preprocessed to match the structure of the other lists
            this.preprocessData(response.data.downloads, this.initFilter);
          } else {
            if (this.config.withImageMap) {
              this.initImageMapFilter(response.data.items);
            } else {
              this.initFilter(response.data.items);
            }
          }
        })
        .catch(error => {
          console.error(error);
          this.setLoadingData(false);
        });
    },
    preprocessData(downloads, callback) {
      const category = Object.keys(downloads)[0];
      const remoteData = downloads[category];

      let items = [];
      // Get the required category-keys
      const categories = {};
      const categoryKeys = []; // Performance-optimization - store keys
      this.configFilters.forEach(x => {
        categories[x.key] = x.label;
        categoryKeys.push(x.key);
      });
      // Get keyword-translations
      axios
        .get(this.config.mappingUrl)
        .then(response => {
          for (const filter of this.configFilters) {
            delete Object.assign(remoteData.filterCategories, {
              [filter.key]: remoteData.filterCategories[filter.key]
            })[filter.key];
          }
          const mappings = response.data;

          /**
           * TODO: This whole block should be rethought and refactored
           */
          // Adjust item-structure
          items = remoteData.files;

          this.fetchItemsCounter++;

          // Change urls to files
          for (const [index, item] of items.entries()) {
            // add indentifier if not available
            if (!item.identifier) {
              item.identifier = `item-${this.fetchItemsCounter}-${index}`;
            }

            // Add filterCategories to the items
            item.filterCategories = {};
            item.text = {};

            this.mapItemValues(item, mappings, category);

            for (const categoryKey of categoryKeys) {
              const categoryName = categories[categoryKey];
              if (
                category === DownloadCategory.APPROVALS &&
                (categoryKey === CategoryKeys.REGION ||
                  categoryKey === CategoryKeys.APPLICATION ||
                  categoryKey === CategoryKeys.PRODUCT_CODELIST ||
                  categoryKey === CategoryKeys.SCHEME ||
                  categoryKey === CategoryKeys.SCOPE ||
                  categoryKey === CategoryKeys.DETAIL)
              ) {
                const itemList = [];
                if (categoryKey === CategoryKeys.PRODUCT_CODELIST) {
                  item.productcodeList.forEach(listItem =>
                    listItem["title"].forEach(dataItem => {
                      if (!itemList.includes(dataItem)) {
                        itemList.push(dataItem);
                      }
                    })
                  );
                  item[categoryKey] = itemList;
                } else {
                  item.productcodeList.forEach(listItem =>
                    listItem[categoryKey].forEach(dataItem => {
                      if (!itemList.includes(dataItem)) {
                        itemList.push(dataItem);
                      }
                    })
                  );
                  item[categoryKey] = itemList;
                }
              }
              item.filterCategories[categoryKey] = item[categoryKey];
              switch (categoryKey) {
                case CategoryKeys.APPROVAL_AUTHORITY:
                  item.text[categoryName] = item[categoryKey];

                  if (category === DownloadCategory.CERTIFICATES) {
                    // Add certificate specific wtParams
                    item.wtParams = {
                      ...item.wtParams,
                      description: item[categoryKey]
                    };

                    // Add certificate specific validto text (is not a filterCategory)
                    item.text[
                      this.config.texts.validto
                    ] = convertISODateTimeToLocaleDate(
                      item.validto,
                      window.currentLanguage
                    );
                  }
                  break;
                case CategoryKeys.PRODUCT_CODE:
                  // Make productcodes expandable
                  item.subHeading = {};
                  item.subHeading[categoryName] = item[categoryKey];
                  break;
                case CategoryKeys.PRODUCT_CODELIST:
                  if (category === DownloadCategory.APPROVALS) {
                    const itemList = [];
                    item.productcodeList.forEach(listItem =>
                      listItem.title.forEach(dataItem => {
                        if (!itemList.includes(dataItem)) {
                          itemList.push(dataItem);
                        }
                      })
                    );
                    item.subHeading = {};
                    item.subHeading[categoryName] = itemList;
                  }
                  break;
                case CategoryKeys.REGION:
                  if (category === DownloadCategory.APPROVALS) {
                    const itemList = [];
                    item.productcodeList.forEach(listItem =>
                      listItem.region.forEach(dataItem => {
                        if (!itemList.includes(dataItem)) {
                          itemList.push(dataItem);
                        }
                      })
                    );
                    item.text[categoryName] = itemList;
                  }
                  break;
                case CategoryKeys.APPLICATION:
                  if (category === DownloadCategory.APPROVALS) {
                    const itemList = [];
                    item.productcodeList.forEach(listItem =>
                      listItem.application.forEach(dataItem => {
                        if (!itemList.includes(dataItem)) {
                          itemList.push(dataItem);
                        }
                      })
                    );
                    item.text[categoryName] = itemList;
                  }
                  break;
                case CategoryKeys.SCOPE:
                  if (category === DownloadCategory.APPROVALS) {
                    const itemList = [];
                    item.productcodeList.forEach(listItem =>
                      listItem.scope.forEach(dataItem => {
                        if (!itemList.includes(dataItem)) {
                          itemList.push(dataItem);
                        }
                      })
                    );
                    item.text[categoryName] = itemList;
                  }
                  if(category === DownloadCategory.CERTIFICATES) {
                    item.text[categoryName] = item[categoryKey];
                  }
                  break;
                case CategoryKeys.SCHEME:
                  if (category === DownloadCategory.APPROVALS) {
                    const itemList = [];
                    item.productcodeList.forEach(listItem =>
                      listItem.scheme.forEach(dataItem => {
                        if (!itemList.includes(dataItem)) {
                          itemList.push(dataItem);
                        }
                      })
                    );
                    item.text[categoryName] = itemList;
                  }
                  break;
                case CategoryKeys.DETAIL:
                  if (category === DownloadCategory.APPROVALS) {
                    const itemList = [];
                    item.productcodeList.forEach(listItem =>
                      listItem.detail.forEach(dataItem => {
                        if (!itemList.includes(dataItem)) {
                          itemList.push(dataItem);
                        }
                      })
                    );
                    item.text[categoryName] = itemList;
                  }
                  break;
                case CategoryKeys.REGION:
                  if (category === DownloadCategory.APPROVALS) {
                    const itemList = [];
                    item.productcodeList.forEach(listItem => itemList.push(listItem.region.forEach(dataItem => itemList.push(dataItem))));
                    item.text[categoryName] = itemList;
                  }
                  break;
                case CategoryKeys.APPLICATION:
                  if (category === DownloadCategory.APPROVALS) {
                    const itemList = [];
                    item.productcodeList.forEach(listItem => itemList.push(listItem.application.forEach(dataItem => itemList.push(dataItem))));
                    item.text[categoryName] = itemList;
                  }
                  break;
                case CategoryKeys.SCOPE:
                  if (category === DownloadCategory.APPROVALS) {
                    const itemList = [];
                    item.productcodeList.forEach(listItem => itemList.push(listItem.scope.forEach(dataItem => itemList.push(dataItem))));
                    item.text[categoryName] = itemList;
                  }
                  break;
                case CategoryKeys.SCHEME:
                  if (category === DownloadCategory.APPROVALS) {
                    const itemList = [];
                    item.productcodeList.forEach(listItem => itemList.push(listItem.scheme.forEach(dataItem => itemList.push(dataItem))));
                    item.text[categoryName] = itemList;
                  }
                  break;
                case CategoryKeys.DETAIL:
                  if (category === DownloadCategory.APPROVALS) {
                    const itemList = [];
                    item.productcodeList.forEach(listItem => itemList.push(listItem.detail.forEach(dataItem => itemList.push(dataItem))));
                    item.text[categoryName] = itemList;
                  }
                  break;
                default:
                  item.text[categoryName] = item[categoryKey];
                  break;
              }
            }
          }
          callback.apply(this, [items]);
        })
        .catch(error => console.error(error));
    },
    mapItemValues(item, mappings, category) {
      const urlPrefix = window.externalDocumentPrefixes[category] || "";
      item.files = [...new Set(item.urls)];
      const langItem = item.files.find(
        langItem => langItem.language === window.currentLanguage.toLowerCase()
      );
      const title = langItem && langItem.title ? langItem.title : item.title;
      item.title = `${title} (${item.certificateId})`;
      item.urls.forEach(x => {
        x.flag = mappings.languages[x.language] || "";
        x.url = `${urlPrefix}${x.url}`;
      });

      if (category !== DownloadCategory.CERTIFICATES) {
        this.mapKeyWordsAndProductTypes(item, mappings);
      }
      else
      {
        this.mapRegionAreas(item, mappings);
      }

      this.mapEconomicAreas(item, mappings);
    },
    mapEconomicAreas(item, mappings) {
      item.economicArea = item.economicArea.map(
        x =>
          getValueByParameterCaseInsensitive(mappings.economicAreas, x) ||
          getValueByParameterCaseInsensitive(mappings.countries, x) ||
          x
      );
    },
    mapRegionAreas(item, mappings) {
      item.regionList = item.regionList.map(
        x => getValueByParameterCaseInsensitive(mappings.countries, x) || x
      );
    },
    mapKeyWordsAndProductTypes(item, mappings) {
      item.keywords = item.keywords.map(
        x => mappings.keywords[x.id] || x.keyword
      );

      // Add productTypes if they are available
      item.productTypes =
        (!!item.product && [item.product]) || item.productcode || [];
    },
    canShowSearch() {
      // just faq search is provided so far
      return (
        this.config.hasSearch && this.config.listCategory === ListCategory.FAQ
      );
    },
    getFaqSearchResults(searchArray) {
      this.reset(true);
      if (
        !searchArray ||
        !searchArray.length ||
        (searchArray.length === 1 && searchArray[0] === "")
      ) {
        this.getContentFromUrl(this.config.url);
      } else {
        this.setLoadingData(true);
        getSearchResultFromUrl(this.config.searchService, {
          from: 0,
          size: 0,
          container: this.searchContainer,
          disableExternalDocuments: this.disableExternalDocuments,
          categoryuid: "faqs",
          word: searchArray
        })
          .then(responseData => {
            this.mapFaqSearchResult(responseData);
          })
          .catch(error => {
            console.error(error);
            this.setLoadingData(false);
          });
      }
    },
    mapFaqSearchResult(responseData) {
      const results = ((responseData.hits && responseData.hits.hits) || [])
        .filter(
          item =>
            !this.allowOnlyInitialIds ||
            (item._source.faqId &&
              this.allowedIds.includes(item._source.faqId.toString()))
        )
        .map(item => {
          return {
            ...item._source,
            answer: item._source.description,
            id: item._source.faqId,
            question: item._source.title
          };
        });
      this.handleFaqSearchResult(results);
    },
    handleFaqSearchResult(data) {
      let resultList = [];
      if (data) {
        let filterCategories = {};
        for (const result of data) {
          let branches = [];
          let productlines = [];
          let measuredRanges = [];
          let types = [];
          let categoryArray = [];

          if (result.branch && result.branch.length) {
            for (const item of result.branch) {
              branches.push(item);
            }
          }

          if (result.productTypes && result.productTypes.length) {
            for (const item of result.productTypes) {
              types.push(item);
            }
          }

          if (result.productline && result.productline.length) {
            for (const item of result.productline) {
              productlines.push(item);
            }
          }

          if (result.measured_range && result.measured_range.length) {
            for (const item of result.measured_range) {
              measuredRanges.push(item);
            }
          }

          categoryArray.push(measuredRanges, productlines, branches, types);

          for (const index in this.categoryKeys) {
            if (categoryArray[index]) {
              filterCategories = {
                ...filterCategories,
                [this.categoryKeys[index]]: categoryArray[index]
              };
            }
          }

          resultList.push({
            question: result.question,
            answer: result.answer,
            id: result.id,
            filterCategories: filterCategories
          });
        }
      }
      this.filteredItems = resultList;
      this.preFiltersProcessed = false;
      this.hasResults = !!resultList.length;
      this.initFilter(resultList);
    },
    compareValues(key, order = "asc") {
      return function innerSort(a, b) {
        if (!a.sorting || !b.sorting) {
          return 0;
        }
        if (!a.sorting.hasOwnProperty(key) || !b.sorting.hasOwnProperty(key)) {
          return 0;
        }
        const varA =
          typeof a.sorting[key] === "string"
            ? a.sorting[key].toUpperCase()
            : a.sorting[key];
        const varB =
          typeof b.sorting[key] === "string"
            ? b.sorting[key].toUpperCase()
            : b.sorting[key];
        let comparison = 0;
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
        return order === "desc" ? comparison * -1 : comparison;
      };
    },
    initImageMapFilter(data) {
      this.jsonItems = data;
      const detail = { id: "all" };
      this.updateFromLink(detail);
    },
    initFilter(data) {
      this.setLoadingData(true);
      this.jsonItems = data;
      this.fullJsonItems = !this.preFiltersProcessed
        ? data
        : this.fullJsonItems;
      this.categoryKeys =
        data && data.length ? Object.keys(data[0].filterCategories) : [];
      this.configFilters = JSON.parse(JSON.stringify(this.config.filters));
      const selectOptionsBuffer = [];
      let presets = this.initPreselection();
      for (const filter of this.configFilters) {
        if (
          filter.include &&
          filter.include.length !== 0 &&
          !this.preFiltersProcessed
        ) {
          this.preFilterCategories.push(filter.key);
          this.preFilterValues.push(filter.include[0]);
          filter.initialSelectOption = filter.include[0];
        } else if (!this.preFiltersProcessed) {
          if (presets["selectedCategory"] && presets["selectedCountry"]) {
            filter.key === this.configFilters[0].key &&
              (this.preFilterValues.push(presets["selectedCategory"]),
              this.preFilterCategories.push(filter.key),
              (filter.initialSelectOption = presets["selectedCategory"]));
            filter.key === this.configFilters[1].key &&
              (this.preFilterValues.push(presets["selectedCountry"]),
              this.preFilterCategories.push(filter.key),
              (filter.initialSelectOption = presets["selectedCountry"]));
          } else if (presets[filter.key]) {
            this.preFilterCategories.push(filter.key);
            this.preFilterValues.push(presets[filter.key]);
          }
        }
      }
      for (let i = 0; i < data.length; i++) {
        const keys = this.configFilters.map(e => e.key);
        const values = keys.map(e => data[i].filterCategories[e]);

        for (let j = 0; j < keys.length; j++) {
          if (values[j]) {
            if (!selectOptionsBuffer[j]) {
              selectOptionsBuffer[j] = [];
            }

            if (!Array.isArray(values[j])) {
              if (!selectOptionsBuffer[j].includes(values[j])) {
                selectOptionsBuffer[j].push(values[j]);
              }
            } else {
              for (const value of values[j]) {
                if (!selectOptionsBuffer[j].includes(value)) {
                  selectOptionsBuffer[j].push(value);
                }
              }
            }
          }
        }
      }

      this.selectOptions = this.sortFilterOptions(selectOptionsBuffer);

      if (this.preFilterValues.length !== 0 && !this.preFiltersProcessed) {
        this.preFilterResults();
        return;
      } else {
        this.preFiltersProcessed = true;
      }
      if (this.config.loadInitialData) {
        if (this.config.sorting) {
          this.filteredItems = data.sort(
            this.compareValues(
              this.config.sorting.field,
              this.config.sorting.ascending ? "asc" : "desc"
            )
          );
        } else {
          this.filteredItems = data;
        }
      }
      this.setLoadingData(false);
      this.hasResults = !!this.filteredItems.length;
      this.$emit("filtered", this.filteredItems);
    },
    sortFilterOptions(selectOptionsBuffer) {
      for (let i = 0; i < selectOptionsBuffer.length; i++) {
        const currentFilter = this.configFilters[i];
        if (currentFilter && currentFilter.sort) {
          if (currentFilter.dataType === FormFilterDataTypeEnum.MONTH) {
            selectOptionsBuffer[i].sort((a, b) => {
              const nameA = currentFilter.monthLabels.indexOf(a);
              const nameB = currentFilter.monthLabels.indexOf(b);
              return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
            });
          } else {
            sortInGivenArray(selectOptionsBuffer[i], currentFilter.sort);
          }
        }
        selectOptionsBuffer[i].unshift(`${this.config.resetSelectOption}`);
      }

      return selectOptionsBuffer;
    },
    sortFilters(choosedItems) {
      let filterItems = this.jsonItems;
      for (const filter of choosedItems) {
        filterItems = filterItems.filter(item => {
          const itemCategory = item.filterCategories[filter[0]];
          const filterValue = filter[1];
          if (itemCategory) {
            return typeof itemCategory === "string"
              ? itemCategory === filterValue
              : itemCategory.includes(filterValue);
          }
          return false;
        });
      }
      this.initFilter(filterItems);
    },
    preFilterResults() {
      for (let i = 0; i < this.preFilterCategories.length; i++) {
        if (
          this.selectOptions.findIndex(optionGroup =>
            optionGroup.includes(this.preFilterValues[i])
          ) > -1
        ) {
          this.filters.push({
            [this.preFilterCategories[i]]: this.preFilterValues[i]
          });
        }
      }
      this.preFiltersProcessed = true;
      this.filterResults();
    },
    updateFromTeaser(title) {
      this.configFilters[0].initialSelectOption = title;
      this.updateFilters({
        label: Object.keys(this.data.items[0].filterCategories)[0],
        initialSelectOption: title
      });
    },
    updateFromLink(detail) {
      this.setLoadingData(true);
      this.filteredItems = [];
      let products = [];
      const items = [];
      for (const filter of this.config.filterList) {
        if (filter.id === detail.id) {
          products = filter.products;
        }
      }
      for (const item of this.jsonItems) {
        if (products.includes(item.id)) {
          items.push(item);
        }
      }
      this.filteredItems = items.sort(
        (a, b) => products.indexOf(a.id) - products.indexOf(b.id)
      );
      this.setLoadingData(false);
      this.hasResults = !!this.filteredItems.length;
      this.$emit("filtered", this.filteredItems);
      this.$emit("has-results", true);
    },
    updateFilters(filter) {
      const query = location.search.substr(1);
      const params = new URLSearchParams(query);
      for (const item of this.filters) {
        if (Object.keys(item)[0] === filter.key) {
          this.filters = this.filters.filter(
            filterItem => Object.keys(filterItem)[0] !== filter.key
          );
          this.preFilterCategories = this.preFilterCategories.filter(
            filterCategories => filterCategories !== filter.key
          );
          params.has(filter.key) && params.delete(filter.key);
        }
      }
      if (filter.initialSelectOption !== this.config.resetSelectOption) {
        this.filters.push({ [filter.key]: filter.initialSelectOption });
        params.append(filter.key, filter.initialSelectOption);
      }
      const urlWithNewParams = `${location.pathname}?${params.toString()}`;
      history.pushState(null, "", urlWithNewParams);
      this.jsonItems = this.fullJsonItems;
      this.filterResults();
    },
    filterResults() {
      this.setLoadingData(true);
      let filteredItems = this.jsonItems;
      let choosedItems = [];
      for (const filter of this.filters) {
        const filterKey = Object.keys(filter)[0];
        const filterValue = filter[filterKey];
        filteredItems = filteredItems.filter(item => {
          const itemCategory = item.filterCategories[filterKey];
          if (itemCategory) {
            return typeof itemCategory === "string"
              ? itemCategory === filterValue
              : itemCategory.includes(filterValue);
          }
          return false;
        });
        choosedItems.push([filterKey, filterValue]);
      }
      if (this.config.sorting) {
        this.filteredItems = filteredItems.sort(
          this.compareValues(
            this.config.sorting.field,
            this.config.sorting.ascending ? "asc" : "desc"
          )
        );
      } else {
        this.filteredItems = filteredItems;
      }
      if (!this.config.withTeasers) {
        this.sortFilters(choosedItems);
      }
      this.filteredItems = filteredItems;
      this.setLoadingData(false);
      this.hasResults = !!filteredItems;
      this.$emit("filtered", this.filteredItems);
      this.$emit("has-results", true);
    },
    initPreselection() {
      const query = location.search.substr(1);
      const result = {};
      const regexPlus = /\+/g;
      if (query === "") {
        return result;
      }

      query.split("&").forEach(function(part) {
        const item = part.split("=");
        item[1] = regexPlus.test(item[1])
          ? item[1].replace(regexPlus, "%20")
          : item[1];
        result[item[0]] = decodeURIComponent(item[1]);
      });
      return result;
    },
    searchReset(inputField) {
      if (this.allowReset && inputField.length === 0) {
        this.jsonItems = this.data.items;
        this.fullJsonItems = this.data.items;
        this.filterResults();
      }
    },
    reset(preventInputReset) {
      this.preFilterCategories = [];
      this.preFilterValues = [];
      this.preFiltersProcessed = false;
      const query = location.search.substr(1);
      const params = new URLSearchParams(query);

      this.filters = [];
      for (let index = 0; index < this.configFilters.length; index++) {
        this.configFilters[
          index
        ].initialSelectOption = this.config.resetSelectOption;
        const filterKey = this.configFilters[index].key;
        params.has(filterKey) && params.delete(filterKey);
      }

      if (!preventInputReset) {
        this.$refs.FilterForm.reset();
      }

      this.jsonItems = this.data.items;
      this.fullJsonItems = this.data.items;
      const urlWithNewParams = `${location.pathname}?${params.toString()}`;
      history.pushState(null, "", urlWithNewParams);

      this.filterResults();
    },
    getInitialFilterValue(configFilter) {
      const matchedFilterIndex = this.filters.findIndex(
        filter => Object.keys(filter)[0] === configFilter.key
      );
      configFilter.initialSelectOption =
        matchedFilterIndex > -1
          ? this.filters[matchedFilterIndex][configFilter.key]
          : configFilter.initialSelectOption;
    },
    setLoadingData(isLoading) {
      this.loadData = isLoading;
      this.$emit("loadingChange", isLoading);
    }
  },
  mounted() {
    window.addEventListener("updateFilter", event => {
      this.updateFromLink(event.detail);
    });
    if (this.config.url) {
      this.configFilters = JSON.parse(JSON.stringify(this.config.filters));
      this.getContentFromUrl(this.config.url);
    } else if (this.config.inlineData) {
      this.hasResults = false;
      this.initFilter(this.config.inlineData.items);
    }
    if (this.config.filters && this.config.filters.length) {
      this.initialSelectOption = this.config.filters[0].initialSelectOption;
    }
  },
  beforeDestroy() {
    if (this.configFilters[0]) {
      this.configFilters[0].initialSelectOption = this.initialSelectOption;
    }
  },
  destroyed() {
    window.removeEventListener("updateFilter", event => {
      this.updateFromLink(event.detail);
    });
  }
};
</script>

<style module lang="scss">
@import "./FormFilter.scss";
</style>
